export const normalizeDisplayPricePercentage = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return 100;
  return n;
};

export const applyDisplayPrice = (price, percentage = 100) => {
  const num = Number(price);
  if (!Number.isFinite(num)) return price;
  const pct = normalizeDisplayPricePercentage(percentage);
  if (pct === 100) return num;
  return Math.round((num * pct) / 100 * 100) / 100;
};

export const reverseDisplayPrice = (displayPrice, percentage = 100) => {
  const num = Number(displayPrice);
  if (!Number.isFinite(num)) return displayPrice;
  const pct = normalizeDisplayPricePercentage(percentage);
  if (pct === 100) return num;
  return Math.round((num * 100) / pct * 100) / 100;
};

export const formatDisplayPrice = (price, percentage = 100, { prefix = "", suffix = "" } = {}) => {
  const displayed = applyDisplayPrice(price, percentage);
  if (!Number.isFinite(Number(displayed))) return `${prefix}${price ?? 0}${suffix}`;
  return `${prefix}${displayed}${suffix}`;
};

export const applyDisplayPriceRange = (rangeStr, percentage = 100) => {
  if (!rangeStr || typeof rangeStr !== "string" || !rangeStr.includes(" - ")) {
    return rangeStr;
  }
  const [low, high] = rangeStr.split(" - ").map((part) => part.trim());
  return `${applyDisplayPrice(low, percentage)} - ${applyDisplayPrice(high, percentage)}`;
};
